import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import GaramMasalaImage from '../assets/banners/spices.jpg';
import { FaHotjar, FaBalanceScale, FaMortarPestle, FaGlobeAsia } from 'react-icons/fa';

const GaramMasala = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const [email, setEmail] = useState('');

    const handleEnquiry = () => {
        const subject = encodeURIComponent("Garam Masala Order Enquiry");
        const body = encodeURIComponent(
            `Hi,\n\nI am interested in placing an order or getting a quotation for your Garam Masala.\n\nPlease contact me back at: ${email}\n\nThanks,\n`
        );
        window.location.href = `mailto:yourmail@example.com?subject=${subject}&body=${body}`;
    };

    return (
        <div className="text-gray-800 bg-white">
            {/* Hero Section */}
            <section className="bg-orange-100 py-16 px-4 text-center" data-aos="fade-down">
                <h1 className="text-4xl md:text-5xl font-bold text-orange-700 mb-4">Authentic Garam Masala</h1>
                <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
                    Crafted from a premium blend of aromatic spices. Enhances the flavor of every Indian dish with rich, traditional taste.
                </p>
            </section>

            {/* Image and Details Section */}
            <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-10 items-center">
                <div data-aos="zoom-in">
                    <img
                        src={GaramMasalaImage}
                        alt="Garam Masala"
                        className="rounded-xl shadow-xl"
                    />
                </div>
                <div data-aos="fade-left">
                    <h2 className="text-3xl font-semibold text-orange-700 mb-6">Why Our Garam Masala Stands Out?</h2>
                    <ul className="space-y-4 text-gray-700">
                        <li className="flex items-start gap-3"><FaHotjar className="text-orange-600 mt-1" />Expertly balanced blend of handpicked spices</li>
                        <li className="flex items-start gap-3"><FaHotjar className="text-orange-600 mt-1" />Stone-ground for maximum flavor retention</li>
                        <li className="flex items-start gap-3"><FaHotjar className="text-orange-600 mt-1" />Free from additives and artificial preservatives</li>
                        <li className="flex items-start gap-3"><FaHotjar className="text-orange-600 mt-1" />Adds depth and warmth to curries, biryanis & more</li>
                        <li className="flex items-start gap-3"><FaHotjar className="text-orange-600 mt-1" />Suitable for domestic and international kitchens</li>
                    </ul>
                </div>
            </section>

            {/* Specifications Section */}
            <section className="bg-orange-50 py-14 px-4" data-aos="fade-up">
                <div className="max-w-5xl mx-auto">
                    <h3 className="text-3xl font-bold text-orange-700 text-center mb-10">Product Specifications</h3>
                    <div className="grid md:grid-cols-2 gap-8">
                        <table className="w-full text-sm border border-orange-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 text-left bg-orange-100">Form</th>
                                    <td className="p-4">Coarse Ground / Fine Powder</td>
                                </tr>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 bg-orange-100">Main Ingredients</th>
                                    <td className="p-4">Coriander, Cumin, Clove, Cardamom, Black Pepper, Cinnamon, Nutmeg</td>
                                </tr>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 bg-orange-100">Origin</th>
                                    <td className="p-4">India</td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-orange-100">Packaging Options</th>
                                    <td className="p-4">100g, 250g, 500g, 1kg | Pouch, Jar, Bulk Bag</td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="w-full text-sm border border-orange-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-orange-200">
                                    <th className="p-4 text-left bg-orange-100">Shelf Life</th>
                                    <td className="p-4">12 – 18 months</td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-orange-100">Usage</th>
                                    <td className="p-4">Curries, Gravies, Biryanis, Marinades, Snacks, Tandoori Dishes</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Quality & Logistics Icons Section */}
            <section className="max-w-6xl mx-auto py-16 px-4 grid md:grid-cols-4 gap-6 text-center" data-aos="fade-up">
                <div>
                    <FaMortarPestle className="text-4xl mx-auto text-orange-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Traditional Stone Grinding</h4>
                </div>
                <div>
                    <FaBalanceScale className="text-4xl mx-auto text-orange-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Perfectly Balanced Blend</h4>
                </div>
                <div>
                    <FaGlobeAsia className="text-4xl mx-auto text-orange-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Export Quality Standard</h4>
                </div>
                <div>
                    <FaHotjar className="text-4xl mx-auto text-orange-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Fresh & Fragrant</h4>
                </div>
            </section>

            {/* Enquiry Section */}
            <section className="bg-orange-100 py-10 px-4" data-aos="fade-up">
                <div className="max-w-xl mx-auto text-center">
                    <h3 className="text-2xl font-bold text-orange-800 mb-4">Send Us an Enquiry</h3>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Your Email Address"
                        className="w-full p-3 rounded border border-orange-300 mb-4 focus:outline-none"
                    />
                    <button
                        onClick={handleEnquiry}
                        className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded-lg transition-all"
                    >
                        Send Enquiry
                    </button>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default GaramMasala;
